/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum AwsSsmAutomationExecutionStatus {
    Pending = 'Pending',
    InProgress = 'InProgress',
    Waiting = 'Waiting',
    Success = 'Success',
    TimedOut = 'TimedOut',
    Cancelling = 'Cancelling',
    Cancelled = 'Cancelled',
    Failed = 'Failed',
    PendingApproval = 'PendingApproval',
    Approved = 'Approved',
    Rejected = 'Rejected',
    Scheduled = 'Scheduled',
    RunbookInProgress = 'RunbookInProgress',
    PendingChangeCalendarOverride = 'PendingChangeCalendarOverride',
    ChangeCalendarOverrideApproved = 'ChangeCalendarOverrideApproved',
    ChangeCalendarOverrideRejected = 'ChangeCalendarOverrideRejected',
    CompletedWithSuccess = 'CompletedWithSuccess',
    CompletedWithFailure = 'CompletedWithFailure'
}
